<template>
    <div :class="['sheetGroups', `sheetGroups-${mode}`]">
        <Tabs class="sheetGroups-content" v-model="value" @on-click="select">
            <TabPane
                v-for="groupItem in groupList"
                :key="groupItem._key"
                :name="groupItem._key"
                :class="['sheetGroups-content-item']"
                :label="groupItem.name"
            ></TabPane>
            <TabPane
                v-for="groupItem in customGroups"
                :key="groupItem._key"
                :name="groupItem._key"
                :class="['sheetGroups-content-item']"
                :label="groupItem.name"
            ></TabPane>
            <div slot="extra" class="sheetGroups-content-extra">
                <slot></slot>
            </div>
        </Tabs>
    </div>
</template>

<script>
    export default {
        name: "sheetGroups",
        props: {
            groups: {
                type: Array,
                default () {
                    return [];
                }
            },
            customGroups: {
                type: Array,
                default () {
                    return [];
                }
            },
            mode: {
                type: String,
                default: "creative" // tradition || creative || page
            }
        },
        data () {
            return {
                value: ""
            };
        },
        computed: {
            groupList () {
                return this.groups;
            }
        },
        created () {
        },
        mounted () {

        },
        methods: {
            select (name) {
                let currentGroup = this.groups.find(item => item._key === name);
                if (currentGroup) {
                    this.$emit("select", currentGroup);
                } else {
                    this.$emit("custom-select", this.customGroups.find(item => item._key === name));
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/attach/sheetGroups.vue